<script setup>
const props = defineProps({
  filters: { type: Array, default: [] },
  minPrice: {
    type: Number,
    default: 0,
  },
  maxPrice: {
    type: Number,
    default: Number.MAX_VALUE,
  },
  filterPrice: {
    type: Array,
    default: [0, Number.MAX_VALUE],
  },
  modelValue: {
    type: Array,
    default: [],
  },
});

const emit = defineEmits([
  "onSelectPrice",
  "reset",
  "apply",
  "update:modelValue",
]);

const selectedPrice = computed({
  get() {
    return props.filterPrice;
  },
  set(value) {
    emit("onSelectPrice", value);
  },
});

//
const sortFilters = (a, b) => {
  if (!isNaN(parseFloat(a.name))) {
    return sortNumbers(a, b);
  } else {
    return sortStrings(a, b);
  }
};

const sortStrings = (a, b) => {
  if (a.name < b.name) {
    return -1;
  }

  if (a.name > b.name) {
    return 1;
  }

  return 0;
};

const sortNumbers = (a, b) => {
  return parseFloat(a.name) - parseFloat(b.name);
};
//

const attributes = computed(() => {
  let localStoreAttributes = [];
  props.filters.forEach((attr) => {
    let minValue = 0;
    let maxValue = 0;
    let step = 1;
    if (attr.isRange) {
      let arrValue = attr.allUnicalValues.map((item) => parseFloat(item));
      minValue = Math.min.apply(null, arrValue);
      maxValue = Math.max.apply(null, arrValue);
      step = attr.step;
    }

    localStoreAttributes.push({
      id: attr.public_id,
      name: attr.name,
      isRange: attr.isRange,
      minValue: minValue,
      maxValue: maxValue,
      step: step,
      allValues: Array.from(attr.allValues)
        .map((v) => {
          return {
            id: v.public_id,
            name: v.name,
            filter_id: v.filter_id,
            countProducts: v.countProducts,
          };
        })
        .sort(sortFilters),
    });
  });
  return localStoreAttributes;
});

const modelFilters = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

function getSelectedAttributes(value) {
  let selectedFilters = [];
  for (let i = 0; i < modelFilters.value.length; i++) {
    selectedFilters.push(Object.assign({}, modelFilters.value[i]));
  }
  if (selectedFilters.length) {
    const indexAttr = selectedFilters.findIndex(
      (element) => element.filterId === value.filterId
    );
    if (indexAttr === -1) {
      selectedFilters.push({
        filterId: value.filterId,
        isRange: value.isRange,
        values: value.values,
      });
    } else {
      if (value.values.length) {
        selectedFilters[indexAttr].values = value.values;
      } else {
        selectedFilters.splice(indexAttr, 1);
      }
    }
  } else {
    selectedFilters.push({
      filterId: value.filterId,
      isRange: value.isRange,
      values: value.values,
    });
  }
  modelFilters.value = selectedFilters;
}

function onSelectPrice(value) {
  selectedPrice.value = value;
}

function apply() {
  emit("apply");
}
function reset() {
  emit("reset");
}
</script>

<template>
  <section
    :class="filterPrice[0]
        ? 'min-w-70 w-full rounded-xl p-4'
        : ' rounded-lg p-4 lg:p-0 lg:h-10 flex items-center justify-center lg:justify-start lg:pl-3'
    "
    style="box-shadow: 0px 4px 20px 0px #48507029"
  >
    <template v-if="filterPrice[0]">
      <div class="flex flex-col space-y-4">
        <p-product-filter-price
          :filter="filterPrice"
          :isRange="true"
          :minValue="minPrice"
          :maxValue="maxPrice"
          :priceValue="selectedPrice"
          @on-select-price="onSelectPrice"
        ></p-product-filter-price>
        <p-product-filter-item
          v-if="filters && filters.length"
          v-for="attribute in attributes"
          :filter="attribute"
          :isRange="attribute.isRange"
          :selectedFilters="modelFilters"
          @get-selected-attributes="getSelectedAttributes"
        ></p-product-filter-item>
      </div>
      <div class="flex flex-col justify-center items-center space-y-3 pt-8">
        <p-button
          class="w-47 h-11"
          padding="normal"
          type="secondary"
          fontSize="base"
          height="medium"
          @click="apply"
          >Применить</p-button
        >
        <button
          class="font-semibold text-base hover:text-secondary-300"
          @click="reset"
        >
          Сбросить
        </button>
      </div>
    </template>
    <template v-else>
      <div
        class="text-base w-full text-center lg:font-normal font-medium lg:text-sm text-center"
      >
        Фильтры отсутствуют
      </div>
    </template>
  </section>
</template>
